export default class MobileMenu {
	// Default Settings
	get defaults() {
		return {
			arrows: true,
			animation: "slide",
			duration: 300,
			customArrow:
				'<span class="w-20 relative mb-1.5 -left-5 flex justify-end items-center jdmenu-arrow"><ion-icon class="text-sm text-[22px] text-theme-brown" name="chevron-forward"></ion-icon></span>',
			customBack:
				'<span class="text-theme-brown flex items-center gap-2 ml-5"><ion-icon class="text-sm text-[22px] text-theme-brown" name="chevron-back"></ion-icon> Back</span>',
			theme: "default",
		};
	}

	constructor(element, customOptions = {}) {
		// Settings
		this.settings = {
			...this.defaults,
			...customOptions,
		};

		// Init and Custom Actions
		if (
			typeof customOptions === "object" ||
			customOptions === "startmenu"
		) {
			this.init(element);
		} else {
			switch (customOptions) {
				case "up":
					this.up(element);
					break;
				case "down":
					this.down(element);
					break;
				case "removemenu":
					this.removeMenu(element);
					break;
			}
		}
	}

	// Init
	init(element) {
		this.menu = element;

		const { menu, settings } = this;

		// Check If Theme
		if (settings.theme === "default") {
			menu.classList.add("jd-menu");
		}

		// Set Current Menu Item (Default is the first ul)
		this.currentLevel = menu.querySelector("ul");

		// Set Left Value
		this.left = 0;

		// Add Back Buttons
		menu.querySelectorAll("li > ul").forEach((ul) => {
			const backButton = document.createElement("li");
			backButton.className = "jdmenu-back js-back";
			backButton.innerHTML = `<span>${settings.customBack}</span>`;
			ul.prepend(backButton);
		});

		// Add Arrows
		menu.querySelectorAll("li").forEach((li) => {
			if (li.querySelector("ul")) {
				li.classList.add("hasChild");
				if (settings.customArrow) {
					li.insertAdjacentHTML("beforeend", settings.customArrow);
				}
			}
		});

		// If no animation set duration to 0
		if (settings.animation === false) {
			this.settings.duration = 0;
		}

		// Click Events
		this.clickEvents();

		// Trigger
		this.trigger();
	}

	// Move
	_move(amount, callback) {
		const { menu, settings } = this;

		menu.querySelector("ul").style.transitionDuration =
			`${settings.duration}ms`;
		menu.querySelector("ul").style.left = amount;

		if (callback) {
			setTimeout(callback, settings.duration);
		}
	}

	// Menu Click and Slide / Animate
	clickEvents() {
		const { menu, settings } = this;
		let _ = this;

		menu.querySelectorAll("li").forEach((li) => {
			li.addEventListener("click", function (e) {
				if (this._clicked + settings.duration > Date.now()) return;
				//   if (menu.querySelector('ul').style.transitionDuration !== '0s') return;

				// Set Date Now
				this._clicked = Date.now();

				e.stopPropagation();

				let target = e.target;

				if (li.classList.contains("hasChild")) {
					if (
						target.classList.contains("jdmenu-back") ||
						li.classList.contains("jdmenu-back") ||
						target.closest(".jdmenu-back") ||
						(target.tagName === "A" &&
							target.getAttribute("href") !== "#")
					)
						return;

					_.left -= 100;
					_._move(`${_.left}%`);
					_.currentLevel = li.querySelector("a").nextElementSibling;
					_.currentLevel.style.display = "flex";
				}

				if (li.classList.contains("jdmenu-back")) {
					_.left += 100;
					_._move(`${_.left}%`, function () {
						_.currentLevel = li.parentNode;
						_.currentLevel.style.display = "none";
					});
				}
			});
		});
	}

	// Trigger
	trigger() {
		const { menu, settings } = this;
		let _ = this;

		if (settings.trigger) {
			let trigger = settings.trigger;
			let triggerClose = settings.triggerClose;

			trigger.addEventListener("click", function () {
				if (!menu.classList.contains("isActive")) {
					menu.classList.add("isActive");
					_.left = 0;

					menu.querySelector("ul").style.left = `${_.left}%`;
					menu.querySelectorAll("ul li ul").forEach((ul) => {
						ul.style.display = "none";
					});
				} else {
					menu.classList.remove("isActive");
				}

				menu.style.display =
					menu.style.display === "none" || menu.style.display === ""
						? "block"
						: "none";
			});

			triggerClose.addEventListener("click", function () {
				if (!menu.classList.contains("isActive")) {
					menu.classList.add("isActive");
					_.left = 0;

					menu.querySelector("ul").style.left = `${_.left}%`;
					menu.querySelectorAll("ul li ul").forEach((ul) => {
						ul.style.display = "none";
					});
				} else {
					menu.classList.remove("isActive");
				}

				menu.style.display =
					menu.style.display === "none" || menu.style.display === ""
						? "block"
						: "none";
			});
		}
	}

	// Up
	up(menu) {
		menu.style.display = "none";
	}

	// Down
	down(menu) {
		menu.style.display = "block";
	}

	// Remove Menu
	removeMenu(menu) {
		menu.classList.remove("jd-menu");
		menu.querySelectorAll(".jdmenu-arrow").forEach((arrow) =>
			arrow.remove(),
		);
		menu.querySelectorAll(".jdmenu-back").forEach((back) => back.remove());
	}
}
